// extracted by mini-css-extract-plugin
export default {"navBarDiv":"OurWork_navBarDiv__zoTM-","OurWorkPage":"OurWork_OurWorkPage__Io-wC","currentProjects":"OurWork_currentProjects__SJmPf","pastProjects":"OurWork_pastProjects__ndhoR"};